import React from "react";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { NavLink } from "react-router-dom";
const SocialIcons = () => {
  return (
    <>
      <div className="fixed top-[28%] lg:top-[45%] xl:top-[58%] 2xl:top-[50%] 3xl:top-[] right-0">
        <div className="flex flex-col justify-center items-center gap-1">
          <NavLink
            to={"https://www.facebook.com/vikasfashion"}
            target="_blank"
            className="bg-black text-white p-3"
          >
            <FaFacebookF />
          </NavLink>
          <NavLink
            to={
              "https://www.linkedin.com/company/vikas-fashions-private-limited/"
            }
            target="_blank"
            className="bg-black text-white p-3"
          >
            <FaLinkedinIn />
          </NavLink>
          <NavLink
            to={"https://www.instagram.com/vikas_fashions_private_limited/"}
            target="_blank"
            className="bg-black text-white p-3"
          >
            <FaInstagram />
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default SocialIcons;
